import React, { useState } from "react";

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden mb-2">
      <div
        className="flex items-center justify-between cursor-pointer py-4 px-6 bg-white hover:bg-gray-50 transition-colors"
        onClick={onClick}
      >
        <h3 className="text-base md:text-lg font-semibold text-gray-900 pr-4">
          {question}
        </h3>
        <div className="flex-shrink-0 flex items-center justify-center w-6 h-6 ml-4">
          {isOpen ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M18 12H6"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              />
            </svg>
          )}
        </div>
      </div>
      {isOpen && (
        <div className="px-6 pt-2 pb-6 text-sm md:text-base text-gray-600 leading-relaxed bg-gray-50">
          {answer}
        </div>
      )}
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqItems = [
    {
      question: "Yıkafoni'nin sunduğu hizmetler nelerdir?",
      answer:
        "Yıkafoni, geniş bir temizlik hizmetleri yelpazesi sunar. Bu hizmetler arasında Halı Yıkama, Koltuk Yıkama, Perde Yıkama, Yorgan Yıkama, Yatak Yıkama ve Ev Temizliği bulunmaktadır. Tüm hizmetlerimiz, profesyonel ekipler ve gelişmiş teknolojiler kullanılarak gerçekleştirilmektedir.",
    },
    {
      question: "Yıkafoni'nin iş yeri üyelik uygulaması nedir?",
      answer:
        "İş yeri üyelik uygulaması ile ilgili detaylı bilgi vermek gerekirse, kurumsal müşterilerimize özel avantajlar, toplu siparişlerde indirimler ve öncelikli hizmet gibi faydalar sunuyoruz. Detaylı bilgi ve başvuru için müşteri hizmetlerimizle iletişime geçebilirsiniz.",
    },
    {
      question: "Siparişlerim ne zaman alınır?",
      answer:
        "Siparişinizi oluştururken belirttiğiniz adres ve zaman dilimine göre ekiplerimiz en kısa sürede sizinle iletişime geçerek alım için randevu oluşturacaktır. Genellikle aynı gün veya ertesi gün alım işlemi gerçekleştirilir.",
    },
    {
      question: "Siparişlerim ne zaman teslim edilir?",
      answer:
        "Temizlik süresi hizmet türüne göre değişiklik göstermekle birlikte, halılarınız veya diğer eşyalarınız temizlendikten sonra kalite kontrolünden geçirilir ve en kısa sürede size teslim edilir. Teslimat süresi hakkında siparişiniz sırasında veya sonrasında bilgilendirme yapılacaktır.",
    },
  ];

  return (
    <div className="mt-16 md:mt-20 mb-20 md:mb-40 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2 text-center">
          Sıkça Sorulan Sorular
        </h2>
        <p className="text-sm md:text-base text-gray-600 mb-10 text-center">
          Aklınıza takılan sorular mı var? Lütfen aşağıdaki soruları kontrol
          ediniz.
        </p>
        <div className="space-y-4">
          {faqItems.map((item, index) => (
            <FAQItem
              key={index}
              question={item.question}
              answer={item.answer}
              isOpen={index === openIndex}
              onClick={() => setOpenIndex(index === openIndex ? -1 : index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
